<script lang="ts" setup>
import type { VNode } from 'vue';
const props = defineProps<{
  headerTag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}>();

const slots = defineSlots<{
  title(): VNode;
  description(): VNode;
  action(): VNode;
}>();
</script>
<template>
  <div class="flex flex-col items-center justify-center gap-1.5 px-10 py-20">
    <component
      :is="props.headerTag || 'h2'"
      v-if="'title' in slots"
      class="mb-0 text-center text-base font-normal leading-4"
    >
      <slot name="title" />
    </component>
    <p
      v-if="'description' in slots"
      class="mb-0 text-center text-sm text-gray-600 dark:text-gray-400"
    >
      <slot name="description" />
    </p>
    <div v-if="'action' in slots" class="mt-1 text-center">
      <slot name="action" />
    </div>
  </div>
</template>
